const OfferTypeEnum = Object.freeze({
    NEW: 'NEW',
    TOPUP: 'TOPUP',
    MULTIPLE: 'MULTIPLE'
});

export default OfferTypeEnum;
